import { InteractionStoppedEvent } from '@common/events';

import { ClientEventSystem } from './ClientBase';

/**
 * Client-side system that listens for InteractionStopped events and closes the appropriate UI.
 * This ensures that when an interaction is broken (e.g., due to leashing, target destruction,
 * or server logic), the client's looting or dialogue UI is correctly closed.
 */
export class InteractionUISyncSystem extends ClientEventSystem<'InteractionStopped'> {
  public override eventTypes: 'InteractionStopped'[] = ['InteractionStopped'];

  public override handleEvent(event: InteractionStoppedEvent): void {
    const { entityId, interactionType } = event.payload;
    // Only handle events for the local player
    if (entityId !== this.clientServices.localPlayer.entityId) {
      return;
    }

    // Close relevant UI based on interaction type
    if (interactionType === 'loot' || interactionType === 'pickpocket') {
      this.clientServices.inventoryUI.close();
    } else if (interactionType === 'talk') {
      this.clientServices.dialogue.handleEnded();
    }
  }
}
